import React, {useState, useEffect} from 'react'
import {useLocation, useHistory} from 'react-router-dom'
import {makeStyles} from "@material-ui/core/styles";
import PropTypes from "prop-types";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {ThemeProvider} from "@material-ui/styles";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const useStyles = makeStyles((theme) => ({
    imageIcon: {
        width: '100%',
        maxWidth: 30,
        backgroundColor: theme.palette.background.paper,
        display: 'inline',
        marginLeft: '20px'
    },
    container: {
        marginTop: 30,
        marginLeft: 30
    },
    bread: {
        display: 'inLine'
    },
    handMouse: {
        '&:hover':{
            cursor: 'pointer'
        }
    }
}));

const theme = createMuiTheme({
    typography: {
        fontFamily: [
            '"Lato"',
            '"Roboto"',
            'sans-serif'
        ].join(','),
    },
    palette: {
        primary: {
            main: '#28C339'
        },
        secondary: {
            main: '#011238'
        }
    },
});

const BreadCrumb = (setTitle, theCountryIsHere) => {

    const [textBread, setTextBread] = useState([])
    const [pathBread, setPathBread] = useState([])

    let location = useLocation()
    let history = useHistory()
    let url = location.pathname
    let classes = useStyles()


    useEffect(()=>{
        let urlInArray = url.split('/')
        urlInArray.forEach(function(item){
            if(item === ''){
                setTextBread(['PAGO46 - Centro de Documentación'])
            } else if(item === 'contact-us'){
                setTextBread(textBread => [...textBread, 'Enviar una solicitud'])
            } else {
                setTextBread(textBread => [...textBread, item.charAt(0).toUpperCase() + item.slice(1)])
            }
        })
        setPathBread(['/'])
    }, [url])

    useEffect(()=>{
        if(textBread.length===2) {
            setPathBread(pathBread => [...pathBread, '/'.concat(textBread[1]).toLowerCase()])
        } else if ( url.includes('contact-us') ) {
            setPathBread(pathBread => [...pathBread, '/contact-us/'.concat(url.slice(url.lastIndexOf('/') + 1))])
        } else if(textBread.length===3){
            setPathBread(pathBread => [...pathBread, '/'.concat(textBread[1]).toLowerCase()])
            setPathBread(pathBread => [...pathBread, '/'.concat(textBread[1]).toLowerCase().concat('/').concat(textBread[2]).toLowerCase()])
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [textBread])

    const visualBreadCrumb = () => {
        let response = []
        textBread.length !== 0 && textBread.forEach( function(singlePath, i) {
            if(i===0){
                response.push(textBread[0])
                return response
            }
            if(singlePath.includes('Sobre')){
                if(singlePath.includes('-pago')){
                    response.push(singlePath.replace('-pago46', ' PAGO46'))
                }
            }
            else {
                response.push(singlePath)
                let individualText = response[i]
                let counter = 1
                for(let i = 0; i < counter; i++){
                    if(individualText.includes('-')){
                        individualText = individualText.replace('-', ' ')
                        individualText = individualText.replace('pago46', 'PAGO46')
                        counter++
                    }
                }
                response[i] = individualText
            }
            return response
        })
        return response
    }

    const goBackUrl = () => {
        history.goBack()
    }

    useEffect(()=>{
        if (theCountryIsHere && location.pathname === '/country-error'){
            setTitle('')
            history.goBack()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [theCountryIsHere])

    visualBreadCrumb()

    return(
        <ThemeProvider theme={theme}>
            <div className={classes.container}>
                <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                    {
                        pathBread.length !== 0 && textBread.map( (singlePath, i) => {

                            if(visualBreadCrumb()[i] === 'Enviar una solicitud'){
                                return(
                                    <Link color="primary" onClick={(goBackUrl)} className={classes.handMouse} key={i}>
                                        {visualBreadCrumb()[i]}
                                    </Link>
                                )
                            } else {
                                return(
                                    <Link color="primary" href={(pathBread[i])} key={i}>
                                        {visualBreadCrumb()[i]}
                                    </Link>
                                )
                            }
                        }

                        )
                    }
                </Breadcrumbs>
            </div>
        </ThemeProvider>
    )
}

BreadCrumb.propTypes = {
    theCountryIsHere: PropTypes.bool.isRequired,
}

export default BreadCrumb
